// extracted by mini-css-extract-plugin
module.exports = {"base":"style_base__3KPtR","section":"style_section__20ina","title":"style_title__1HFM-","copyWrapper":"style_copyWrapper__2iCKz","footer":"style_footer__2L6z0"};